















import SettingsPassword from "@/components/settings/Password.vue";
import TwoFactorAuthentication from "@/components/settings/TwoFactorAuthentication.vue";

export default {
  data() {
    return {};
  },
  name: "Settings",
  components: {
    SettingsPassword,
    TwoFactorAuthentication
  }
};
